import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/journals',
    name: 'Journal',
    component: () => import('../views/Journals.vue'),
  },
  {
    path: '/journals/:slug',
    component: () => import('../views/Journal.vue'),
  },
  {
    path: '/store',
    name: 'Store',
    component: () => import('../views/Store.vue'),
  },
  {
    path: '/products/:slug',
    name: 'ProductsByCategory',
    component: () => import('../views/ProductsByCategory.vue'),
  },
  {
    path: '/product/:slug',
    name: 'Product',
    component: () => import('../views/Product.vue'),
  },
  {
    path: '/find-us',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue'),
  },
  {
    path: '*',
    component: () => import('../views/404.vue'),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
